// istanbul ignore file
import { ApolloLink, from } from '@apollo/client'
import { getMainDefinition } from '@apollo/client/utilities'

import bulletLink from './bullet'
import createErrorLink from './error'
import createHttpLink from './http'
import createWebsocketLink from './websocket'

export function createClientLinks(apiURI: string): ApolloLink {
  const httpLink = createHttpLink(apiURI)
  const wsLink = createWebsocketLink()

  if (!wsLink) return from([createErrorLink(), bulletLink, httpLink])

  const transportLink = ApolloLink.split(
    ({ query }) => {
      const definition = getMainDefinition(query)

      return (
        definition.kind === 'OperationDefinition' &&
        definition.operation === 'subscription'
      )
    },
    wsLink,
    httpLink,
  )

  return from([createErrorLink(), bulletLink, transportLink])
}
